import React from 'react';

import { Icon, type IconName } from '../Icon/Icon';
import { Root, TitleText, CountPill } from './SectionTitle.styles';

export type SectionTitleProps = {
  title: string;
  icon?: IconName;
  iconColor?: string;
  /** i18n interpolation values for the title (e.g. "Campaigns in {{channel}}"). */
  placeholders?: Record<string, string | number>;
  /** Small pill after the title ("3", "{{enabled}} of {{total}}"). */
  count?: string;
  /** i18n interpolation values for the count. */
  countPlaceholders?: Record<string, string | number>;
  className?: string;
};

/**
 * Section heading with an optional leading icon and a trailing count pill. Title renders via
 * `<Text>`. A panel heading, not a page title: drill-in pages get their title from `BackHeader`.
 */
export const SectionTitle = ({
  title,
  icon,
  iconColor,
  placeholders,
  count,
  countPlaceholders,
  className,
}: SectionTitleProps): React.ReactElement => (
  // data-lumio-heading: section titles are styled spans, not <h*> elements, so
  // the Lumio page-context serializer needs this marker to treat them as
  // headings (see src/nova/lib/lumioPageContext.ts).
  <Root className={className} data-lumio-heading="">
    {icon ? <Icon name={icon} size={20} color={iconColor} /> : null}
    <TitleText text={title} placeholders={placeholders} tag="span" />
    {count ? <CountPill text={count} placeholders={countPlaceholders} tag="span" /> : null}
  </Root>
);

export default SectionTitle;
